<template>
    <div>
        <el-table
          ref="filterTable"
          :data="batteryData"
          style="width: 100%">
            <el-table-column
              prop="number"
              label="编号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="dataName"
              label="项目名称"
              width="180">
            </el-table-column>
            <el-table-column
              prop="source"
              label="数据来源">
            </el-table-column>
            <el-table-column
              prop="createDatetime"
              label="创建时间"
              sortable
              column-key="date"
              :filters="[{text: '2016-05-01', value: '2016-05-01'}, {text: '2016-05-02', value: '2016-05-02'}, {text: '2016-05-03', value: '2016-05-03'}, {text: '2016-05-04', value: '2016-05-04'}]"
              :filter-method="filterHandler">
            </el-table-column>
            <el-table-column
              prop="diagnoseDatetime"
              label="诊断时间"
              sortable
              column-key="date"
              :filters="[{text: '2016-05-01', value: '2016-05-01'}, {text: '2016-05-02', value: '2016-05-02'}, {text: '2016-05-03', value: '2016-05-03'}, {text: '2016-05-04', value: '2016-05-04'}]"
              :filter-method="filterHandler">
            </el-table-column>
            <el-table-column
              prop="diagnoseReport"
              label="最新诊断报告"
              width="180"
              @click="loadFile">
                <ProgressBar :progress="99" :width="100" style="display:inline-block;text-align: center;"/>  
            </el-table-column>
            <el-table-column
              prop="diagnoseReport"
              label="诊断操作"
              width="180"
              >
                <template slot-scope="scope">
                    <div 
                    :style="{color: scope.row.diagnoseReport !='null'?'blue':'blue'}">
                        <el-button type="primary" round style="font-size: 10px;padding: 8px;background-color: #0049c8;border:none">一键诊断</el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
              prop="diagnoseReport"
              label="数据管理"
              width="180">
                <template>
                    <div>
                        <i class="el-icon-reading" 
                        style="margin-right:10px;font-size: 20px;"
                        @click="showViewProject"></i>
                        <i class="el-icon-edit-outline" 
                        style="margin-right:10px;font-size: 20px;"
                        @click="showEditProject"></i>
                        <i class="el-icon-delete" 
                        style="margin-right:10px;font-size: 20px;"
                        @click="showDeleteProject"></i>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <PaginationWidget />
        <el-button @click="clearFilter">重置</el-button>
        <ViewProject :is-show="viewProjectVisible" @closeViewDialog="closeViewProject()"/>
        <EditProject :is-show="editProjectVisible" @closeEditDialog="closeEditProject()"/>
        <DeleteProject :is-show="deleteProjectVisible" @closeDeleteDialog="closeDeleteProject()" />
    </div>
</template>
  
<script>
import PaginationWidget from './PaginationWidget.vue'
import ProgressBar from './Utils/ProgressBar.vue'
import EditProject from './DialogView/EditProject.vue';
import DeleteProject from './DialogView/DeleteProject.vue';
import ViewProject from './DialogView/ViewProject.vue';
export default {
    name: 'ProjectData',
      data() {
        return {
          editProjectVisible:false,
          deleteProjectVisible:false,
          viewProjectVisible:false,
            batteryData:[{
            number: '1',
            dataName: 'battery_01',
            source: '电动车',
            createDatetime: '2016-05-02',
            status:'诊断完成',
            diagnoseDatetime:'2016-05-02',
            diagnoseReport: 'battery_01.pdf'
          },
          {
            number: '2',
            dataName: 'battery_02',
            source: '电站',
            createDatetime: '2016-05-02',
            status:'诊断完成',
            diagnoseDatetime:'2016-05-02',
            diagnoseReport: 'battery_02.pdf'
          }]
        }
      },
      components:{
        PaginationWidget,
        ProgressBar,
        EditProject,
        DeleteProject,
        ViewProject
      },
      methods: {
        showEditProject(){
          this.editProjectVisible=true
        },
        showDeleteProject(){
          this.deleteProjectVisible=true
        },
        showViewProject(){
          this.viewProjectVisible=true
        },
        closeEditProject(){
          this.editProjectVisible=false
        },
        closeDeleteProject(){
          this.deleteProjectVisible=false
        },
        closeViewProject(){
          this.viewProjectVisible=false
        },
        loadFile () {
            window.open('pde.pdf')
        },
        resetDateFilter() {
          this.$refs.filterTable.clearFilter('date');
        },
        clearFilter() {
          this.$refs.filterTable.clearFilter();
        },
        formatter(row) {
          return row.address;
        },
        filterTag(value, row) {
          return row.tag === value;
        },
        filterHandler(value, row, column) {
          const property = column['property'];
          return row[property] === value;
        }
      }
    }
  </script>